import React from 'react';
import nest from 'recompose/nest';

import { IntlContextProvider } from 'context/IntlContext';
import { Layout } from 'components/layout';
import { LinksProvider } from 'context/LinksContext';
import { NavigationProvider } from 'context/NavigationContext';

const wrapPageElement = ({ element, props }) => {
  const {
    pageContext: { hideHeaders, locale, name },
    location,
  } = props;

  if (hideHeaders && window.fcWidget) {
    window.fcWidget.destroy();
  }

  const AllPageProviders = nest(
    NavigationProvider,
    IntlContextProvider,
    LinksProvider,
  );

  return (
    <AllPageProviders location={location} currentPageName={name}>
      <Layout locale={locale}>{element}</Layout>
    </AllPageProviders>
  );
};

export default wrapPageElement;
